export type VendorPaymentTiming = "advance" | "post_invoice";

function firstNonEmptyName(
  ...values: (string | null | undefined)[]
): string | null {
  for (const v of values) {
    const s = typeof v === "string" ? v.trim() : "";
    if (s) return s;
  }
  return null;
}

/**
 * Maps list/create/update API payloads to VendorPaymentRow.
 * Backend may use `created_by_name`, `created_by_admin_name`, `created_by_adminname`, or camelCase.
 */
export function normalizeVendorPaymentRow(raw: unknown): VendorPaymentRow {
  const r = raw as Record<string, unknown> & VendorPaymentRow;
  return {
    ...r,
    created_by_name: firstNonEmptyName(
      r.created_by_name as string | null | undefined,
      r.created_by_admin_name as string | null | undefined,
      r.created_by_adminname as string | null | undefined,
      r.createdByName as string | null | undefined,
    ),
    updated_by_name: firstNonEmptyName(
      r.updated_by_name as string | null | undefined,
      r.updated_by_admin_name as string | null | undefined,
      r.updated_by_adminname as string | null | undefined,
      r.updatedByName as string | null | undefined,
    ),
  };
}

export interface VendorPaymentRow {
  id: number;
  pr_id: number;
  amount: string | number;
  payment_timing: VendorPaymentTiming;
  created_at: Date;
  created_by: number | null;
  created_by_name: string | null;
  updated_at: Date;
  updated_by: number | null;
  updated_by_name: string | null;
  deleted_at: Date | null;
  deleted_by: number | null;
  deleted_by_name: string | null;
  active: number;
  payment_mode: string | null;
  remarks: string | null;
}

export interface VendorPaymentFormPayload {
  pr_id: number;
  amount: number;
  payment_timing: VendorPaymentTiming;
  payment_mode?: string | null;
  remarks?: string | null;
}
